import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import MembershipScheduleCreateForm from './MembershipScheduleCreateForm';
import { createMembershipSchedule } from 'store/actions/membership-schedules/createMembershipSchedules';

const MembershipScheduleCreateContainer = ({ translate, history, dispatchForm }) => {
    const handleSubmitForm = (values) => {
        return new Promise((resolve) => {
            dispatchForm({
                onError: resolve,
                onSuccess: () => {
                    resolve(history.push('/membership-schedules'));
                },
                values: values,
            });
        });
    };

    const breadcrumbs = [
        {
            label: translate('menu.sidebar.membership_schedules'),
            link: '/membership-schedules',
        },
        {
            label: translate('actions.create'),
        },
    ];

    return (
        <div>
            <Breadcrumbs breadcrumbs={ breadcrumbs } />

            <Header>
                <Title title={ translate('actions.create') } />

                <Actions>
                    <ListButton url='/membership-schedules' />
                </Actions>
            </Header>

            <Card>
                <CardText>
                    <MembershipScheduleCreateForm form='membership-schedule' handleSubmitForm={ handleSubmitForm } />
                </CardText>
            </Card>
        </div>
    );
};

MembershipScheduleCreateContainer.propTypes = {
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(createMembershipSchedule(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(MembershipScheduleCreateContainer);



// WEBPACK FOOTER //
// ./src/pages/membership-schedules/create/MembershipScheduleCreateContainer.js